module.exports = __webpack_public_path__ + "static/media/mask-up.dbc83f33.jpg";